import {PNode} from '../flash-repo/path-builder/path-builder-domain'

export type EntityId = string | number
export type RepoEntityWithId = {id: EntityId}
export type RepoMapPNode<RepoEntity extends RepoEntityWithId> = PNode<Record<EntityId, RepoEntity>>
export type RepoArrayPNode<RepoEntity extends RepoEntityWithId> = PNode<RepoEntity[]>

export type RepoEntityPredicate<RepoEntity extends RepoEntityWithId> = ((entity: RepoEntity) => boolean) | Partial<RepoEntity>
